import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { FormattedMessage, injectIntl } from '../../../util/reactIntl';
import { Modal } from '../..';
import TransactionTabs from '../utils/TransactionTabs';

import css from './TransactionsModal.css';

const TransactionsModal = props => {
  const {
    className,
    rootClassName,
    id,
    intl,
    isOpen,
    onCloseModal,
    onManageDisableScrolling,
    completedTxs,
    ongoingTxs,
    futureTxs,
    overdueTxs,
    notPaidServiceFeesTxs,
    txType
  } = props;

  useEffect(() => {
    setActiveTab(txType)
  }, [txType])

  const classes = classNames(rootClassName || css.root, className);
  const currentUser = useSelector(state => state.user.currentUser)
  const [activeTab, setActiveTab] = useState(txType || 'overdue');

  const tabs = [
    { id: 'overdue',   label: 'Zaległe',   data: overdueTxs },
    { id: 'ongoing',   label: 'W toku',    data: ongoingTxs },
    { id: 'future',    label: 'Przyszłe',  data: futureTxs },
    { id: 'completed', label: 'Zakończone',data: completedTxs },
    ...(process.env.REACT_APP_COUNTRY_ID === 'pl'
        ? [{ id: 'serviceFees', label: 'Opłaty serwisowe', data: notPaidServiceFeesTxs }]
        : [])
  ];

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      closeButtonMessage={' '}
    >
      <p className={css.modalTitle}>
        <FormattedMessage id="TransactionsModal.title" />
      </p>

      <TransactionTabs
        tabs={tabs}
        currentUser={currentUser}
        txType={txType}
      />
      {/* <div className={css.tabs}>
        {tabs.map(tab => (
          <button
            key={tab}
            className={classNames(css.tab, { [css.activeTab]: activeTab === tab })}
            onClick={() => setActiveTab(tab)}
          >
            <FormattedMessage id={`TransactionsModal.tab.${tab}`} defaultMessage={tab} />
            { transactionData[tab]?.length > 0 &&<span> ({transactionData[tab]?.length})</span>}
          </button>
        ))}
      </div>
      <div className={css.transactionList}>
        {transactions.map(tx => (
          <div key={tx.id.uuid} className={css.transaction}>
            <div className={css.transactionHeader}>
              <div>
                {
                  (currentUser?.attributes.isAdmin || currentUser?.attributes.adminForCountries?.length > 0) ?
                    <NamedLink
                      name="SalePage"
                      params={{ id: tx.id.uuid }}
                      className={css.code}
                    >
                      {tx.attributes.code}
                    </NamedLink> :
                    <span className={css.code}>{tx.attributes.code}</span>
                }
                {!tx.attributes.serviceFee ? <span className={css.txState}><FormattedMessage id={`TransactionsModal.state.${tx.attributes.processState}`} /></span> : <span className={css.txState}>nieopłacona</span>}
              </div>
              {!tx.attributes.serviceFee ? <span>{tx.attributes.start} - {moment(tx.attributes.end).add(-1, 'days').format("YYYY-MM-DD")}</span> : <span>{moment(tx.attributes.createdAt).format("YYYY-MM-DD")}</span>}
            </div>
            {!tx.attributes.serviceFee ?
              <div className={css.listings}>
                {tx.listings.map(l => (
                  <div key={l.id.uuid}>{`${l.meta.seats} x ${l.attributes.title}`}</div>
                ))}
              </div> :
              <div className={css.listings}>
                <div>{tx.attributes.serviceFee.reason}</div>
              </div>
            }
            <div>{tx.provider.attributes.name}</div>
          </div>
        ))}
      </div> */}
    </Modal>
  );
};

TransactionsModal.defaultProps = {
  reviewSent: false,
  sendReviewInProgress: false,
  sendReviewError: null,
};

export default injectIntl(TransactionsModal);
